export default function Hero({ onPlay }) {
  return (
    <div className="hero" data-stagger="120">
      <div className="hero-glow" />
      <div className="hero-grid" />
      <div className="hero-label r">
        <div className="hero-label-dot" />
        Academia activa en Skool
      </div>
      <h1 className="hero-title r">
        Aprende lo que el<br />
        <em>colegio no te enseñó</em>
      </h1>
      <p className="hero-sub r">
        Marketing digital, Emprendimiento, Wellness &amp; Beauty, Lifestyle &amp; Eventos, Creación
        de Podcasts y mucho más — todo en una comunidad que te hace crecer.
      </p>
      <div className="theater-wrap r r-scale" onClick={onPlay} role="button" tabIndex={0}>
        <div className="theater-ratio">
          <img className="theater-thumb" src="/assets/skool-screenshot.png" alt="Preview del curso" />
          <div className="theater-overlay" />
          <div className="theater-play">
            <svg width="22" height="26" viewBox="0 0 22 26" fill="white">
              <path d="M0 0L22 13L0 26V0Z" />
            </svg>
          </div>
          <div className="theater-bar">
            <span className="theater-tag">Preview</span>
            <span className="theater-title-text">Random College · Comunidad en Skool</span>
          </div>
        </div>
      </div>
    </div>
  );
}
